var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "steps-bar",
      class: [_vm.page == "estimate" ? "" : "-mx-8 xl:-mx-20"],
    },
    [
      _c(
        "div",
        {
          staticClass: "steps-bar-overflow",
          class: _vm.steps.length > 3 ? "overflow-auto" : "",
        },
        [
          _c(
            "ul",
            {
              staticClass:
                "flex justify-between text-current whitespace-nowrap w-max",
              class: [_vm.page == "estimate" ? "" : "-mx-8 xl:-mx-20"],
            },
            _vm._l(_vm.steps, function (step, index) {
              return _c(
                "li",
                { key: step.index, staticClass: "block w-1/2 md:w-auto" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "step-btn w-full h-full cursor-pointer border-b border-transparent text-sm md:text-base duration-300 opacity-20 outline-none select-none",
                      class: _vm.value == index ? "active" : "",
                      attrs: { type: "button", disabled: _vm.value == index },
                      on: {
                        click: function ($event) {
                          return _vm.stepClick(index)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-start md:items-center justify-center px-8 md:px-16 py-6 gap-2 md:gap-6 h-full pointer-events-none",
                        },
                        [
                          index >= _vm.value
                            ? _c("span", { staticClass: "min-w-[18px]" }, [
                                _vm._v(_vm._s(index + 1) + "."),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          index < _vm.value
                            ? _c("span", [
                                _c(
                                  "svg",
                                  { staticClass: "w-[18px] h-[14px]" },
                                  [
                                    _c("use", {
                                      attrs: { "xlink:href": "#icon-check" },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-left w-min sm:w-auto" },
                            [_vm._v(_vm._s(step.name))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.theme == "blue"
        ? _c("div", { staticClass: "border-b border-blue/10" })
        : _vm._e(),
      _vm._v(" "),
      _vm.theme == "white"
        ? _c("div", { staticClass: "border-b border-white/40" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }